<div class="d-flex flex-column">
    <div class="d-flex">
        <div class="d-flex my-auto" style="width: 36px; height: 36px;">
          <img src="https://storage.googleapis.com/ashgridx-application-artifacts/public/ashgridx-primary.svg" alt="AshgridX">
        </div>
        <span class="ms-2e my-auto mat-headline-5 fw-bolder">AshGridX</span>
    </div>
  <span class="mt-0 mb-0 mat-body-1">A single account for all our products</span>
</div>
